import { Container } from "react-bootstrap";
import PreCertLinkBanner from "./Shared/Components/PreCertLinkBanner";

export default function ErrorPage() {
    return (
        <header>
               <PreCertLinkBanner/>
            <Container>
                <div>
                    An unexpected error has occurred
                </div>
            </Container>
        </header>
    );
}